import { InternalErrorTemplate } from 'templates/InternalError';

export default function InternalError() {
  return <InternalErrorTemplate />;
}
